
import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { compose, defaultProps } from 'recompose';
import { hot } from 'react-hot-loader';
import SignatureCanvas from 'react-signature-canvas'
import { Form, Message, Button,Icon } from 'semantic-ui-react';
import { withReportEditing } from './report-edit.helper';

import { withLocale } from 'op/components/locale';

import ReportMeta from 'op/components/report/meta';
import ReportFeeback from 'op/components/report/feedback';
import ReportEvaluation from 'op/components/report/evaluation';
import ReportSignatrue from 'op/components/report/signature';
import ReportSubmitModal from 'op/components/report/submit-modal';
import ReportDeleteModal from 'op/components/report/delete-modal';
import ReportUpload from 'op/components/report/upload';
import {useHistory} from "react-router";
const ReportEdit = ({ locale, validation, submitting, person, report, invokeChange, handleKpiAdd, sendReport, deleteReport, justExit, online }) => {
	const history = useHistory();
return(
	<Form error={!validation.ok} loading={ submitting }>
		<button onClick={history.goBack}><Icon name='arrow left'/></button>
		<ReportMeta readOnly={['type', 'category']} report={report} invokeChange={invokeChange} />
		<ReportEvaluation report={report} onKpiAdd={handleKpiAdd} invokeChange={invokeChange} />
		<ReportUpload report={report} invokeChange={invokeChange}  online={online} />
		<ReportFeeback report={report} invokeChange={invokeChange} />
		<ReportSignatrue report={report} invokeChange={invokeChange} />
		<Message
			error
			header={locale._system.validation.negative}
			content={validation.message}
		/>
		<Button.Group fluid>
			<ReportDeleteModal online={online} onDelete={deleteReport} />
			<Button.Or />
			<ReportSubmitModal report={report} 
				validation={validation} online={online}
				onSave={() => sendReport(false)} 
				onSubmit={() => sendReport(true)} 
				onRequestExit={ () => justExit(report) } />
		</Button.Group>
	</Form>)
};

export default compose(
	withLocale(),
	withReportEditing,
	hot(module),
)(ReportEdit);